import { Action, createHook, createStore } from 'react-sweet-state'

import { validateMessage } from '../api/messages'
import { IRequestGetNLUTabs } from '../api/nluData'
import { IMessage } from '../types/messages'

import { IIntent } from './nluDataStore'

interface MessagesState {
    messages: IMessage[]
    entities: string[]
    intents: IIntent[]
    tabs: string[]
}

const MessagesInitialState: MessagesState = {
    messages: [],
    entities: [],
    intents: [],
    tabs: [],
}

const MessagesActions = {
    setMessages:
        (messages: IMessage[]): Action<MessagesState> =>
        ({ setState }) => {
            setState({
                messages,
            })
        },
    setNLUData:
        ({
            entity_labels,
            intents,
            tab_names,
        }: IRequestGetNLUTabs): Action<MessagesState> =>
        ({ setState }) => {
            setState({
                entities: entity_labels,
                intents,
                tabs: tab_names,
            })
        },
    setMessageValidated:
        (id: string): Action<MessagesState> =>
        async ({ setState, getState }) => {
            const messages = structuredClone(getState().messages)

            const messageIndex = messages.findIndex(
                (message) => message._id === id
            )

            const { message_validated } = messages[messageIndex]

            await validateMessage(id, !message_validated)

            if (messageIndex > -1) {
                messages.splice(messageIndex, 1)
            }

            setState({
                messages,
            })
        },
}

const Store = createStore({
    initialState: MessagesInitialState,
    actions: MessagesActions,
})

export const useMessagesStore = createHook(Store)
